import * as moment from 'moment';
import { Entity } from '@decahedron/entity';
import Variables from '@/config/variables';

export default class User extends Entity {
    private variables = new Variables();

    public id: string = null;

    public profileImage: string = null;

    public firstname: string = null;

    public lastname: string = null;

    public company: string = null;

    public email: string = null;

    public vat: string = null;

    public phone: string = null;

    public address: string = null;

    public passportScan: string = null;

    public passportScanVerso: string = null;

    public password: string = null;

    public role: string = null;

    public language = 'en';

    public blockedAt: string = null;

    public get companyOrName(): string {
        return this.company || this.name;
    }

    public get name(): string {
        return `${this.firstname || ''} ${this.lastname || ''}`;
    }

    public get addressHtml(): string {
        return this.address ? this.address.replace(/(?:\r\n|\r|\n)/g, '<br>') : '';
    }

    public get canBuy(): boolean {
        return !!this.vat && !!this.phone && !!this.address && !!this.passportScan;
    }

    public setBlocked() {
        this.blockedAt = moment.default().format('YYYY-MM-DD');
    }
}
